// @flow

export const APP_STATUS = "APP_STATUS";
export const START_GAME = "START_GAME";
export const SHOW_DICE = "SHOW_DICE";
